/*
 * @Description:
 * @Version: 1.0
 * @Autor: dudedu
 * @Date: 2022-12-02 13:09:28
 * @LastEditors: dudedu
 * @LastEditTime: 2023-03-06 15:19:52
 */
import axios from 'axios';
import { Message } from 'element-ui';
import Cookies from 'js-cookie';

// const cache = {
//
// };


// 创建axios实例
const useRequest = axios.create({
  baseURL: `//${window.location.host}/`, // api的base_url
  timeout: 120000, // 请求超时时间,
  // request payload
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  // 修改请求数据,去除data.q中为空的数据项,只针对post请求
});

useRequest.interceptors.request.use(config => config, error => Promise.reject(error));

// 错误码
const retCodeObj = {
  1001: (msg) => {
    // 0alert(response)
    Message.warning(msg);
    return Promise.reject(msg);
  },
  // wps cookie 换取 jwt 错误
  1002: (msg) => {
    // 0alert(response)
    // Message.warning(msg);
    // let thisURL = encodeURIComponent(location.href)
    // window.location.href = `https://account.wps.cn/login?cb=${encodeURIComponent(location.href)}`
    // let to = vueRouter.currentRoute.name
    // vueRouter.push({name: "wpsAuth", query: {callback: to}})
    window.location.href = '/login';
    return Promise.reject(msg);
  },
  // 登录态失效
  1003: () => {
    // Message.warning(msg)
    window.location.href = '/login';
    return Promise.reject('登录态失效');
  },
  // 参数错误
  1004: () => {
    // Message.warning(msg)
    window.location.href = '/login';
    return Promise.reject('登录态失效');
  },
  // 接口异常
  1006: (msg) => {
    Message.warning(msg);
    return Promise.reject('接口异常');
  },

  // 项目已经被删除或者被禁用
  1008: async () => {
    // Message.warning(msg);
    Cookies.remove('CurrentProjectId');
    sessionStorage.removeItem('currentProject');
    await this.$store.dispatch('app/getProjectListSelectedNew');
    await location.reload();
    // return Promise.reject('团队已经被删除或者被禁用，请切换团队');
  },
};


// http response 拦截器
useRequest.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      return false;
    }
    const { code, data, msg } = response.data;
    if (code === 0) {
      // 直接缺少登录态，那么需要直接跳转腾讯云
      // if (needReLoginCloud > 1) {
      //   window.location.href = `https://cloud.tencent.com/login?s_url=${encodeURIComponent('https://openeda.cloud.tencent.com?state=cloud&code=cloud')}`;
      // }
      return data;
    }
    if (data) {
      return Promise.reject(msg);
    }


    if (retCodeObj[code]) {
      // 检查团队子账号是否存在 管理员不显示报错，普通用户正常显示报错
      if (response.config.url === '/api/eda/common/eda/checkProjectTencentAccountExist') {
        const configData = JSON.parse(response.config.data);
        if (configData.isOwner) return Promise.reject();
      }
      return retCodeObj[code](msg);
    }
    // alert(response)
    Message.warning('网络错误');
    return Promise.reject('网络错误');
  },
  (error) => {
    Message.error('网络错误');
    return Promise.reject(error.data);
  },
);


const getRequest = url => useRequest.get(url);
const postRequest = (url, data) => useRequest.post(url, data);
const extraPostRequest = (url, data, extra) => useRequest.post(url, data, { headers: { 'Content-Type': 'application/json', extra: extra.extra.toString() } });

export {
  getRequest,
  postRequest,
  extraPostRequest,
};
